var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsEnum } from 'class-validator';
import { RegenerationMode } from '../enums/regeneration-mode.enum.js';
/**
 * Body of `POST /ai-documentation/dictations/:id/regenerate` (Spec § 9),
 * answered with 202: the new run is enqueued, the overview's polling shows it.
 */
export class RegenerateDictationDto {
    mode;
}
__decorate([
    Expose(),
    IsEnum(RegenerationMode),
    __metadata("design:type", String)
], RegenerateDictationDto.prototype, "mode", void 0);
//# sourceMappingURL=regenerate-dictation.dto.js.map